import { Box, Button, Container, Typography } from '@mui/material';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import { Link as MuiLink } from '@mui/material';
import { ROUTES } from '@src/layout/RoutePage';
import CheckIcon from '@mui/icons-material/Check';
import { useRef } from 'react';

export const SignupSuccessPage = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const initialLocationState = useRef(location.state);
  const { title, email } = initialLocationState.current;

  // Resending needs a reCAPTCHA solve, which lives on the resend-confirmation form.
  const resendCode = () => {
    navigate(ROUTES.resendConfirmation, { state: { email } });
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 4,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography component="h1" variant="h5" sx={{ color: 'primary', mb: '8px' }} align="center">
          {title}
        </Typography>
        <Typography component="h4" variant="body2">
          <strong>Congratulations!</strong> Your sign-up was successful. We have sent a verification email to your
          registered email {email}. Please check your inbox (and spam folder, just in case) and click on the
          verification link to complete your registration. Once you've verified your email, you can{' '}
          <MuiLink component={RouterLink} to={ROUTES.signin} color="primary">
            Log in
          </MuiLink>{' '}
          to your account. Thank you for joining us!
        </Typography>
        <Typography component="span" variant="body2" sx={{ mt: '8px' }}>
          <MuiLink component="button" type="button" variant="body2" onClick={resendCode}>
            Resend confirmation code
          </MuiLink>
        </Typography>
      </Box>
    </Container>
  );
};

export const PasswordResetSuccessPage = () => {
  const navigate = useNavigate();
  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 4,
          display: 'flex',
          flexDirection: 'column',
          // alignItems: 'center',
        }}
      >
        <Typography
          component="div"
          variant="h5"
          sx={{ color: 'primary', mb: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}
          align="center"
        >
          <CheckIcon />
          Password was reset
        </Typography>
        <Typography component="h4" variant="body2">
          Your password has been reset successfully!
        </Typography>
        <Button
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2, textTransform: 'none' }}
          onClick={() => navigate(ROUTES.signin)}
        >
          Return to Sign In
        </Button>
      </Box>
    </Container>
  );
};
